var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.497 10h2.5c.634 0 1.233.288 1.628.782l.541.676c.317.396.796.626 1.302.626h3.064c.506 0 .985-.23 1.302-.626l.54-.676A2.08 2.08 0 0 1 15.003 10h2.501M17.503 9.166V8.75a2.5 2.5 0 0 0-2.5-2.5H4.997a2.5 2.5 0 0 0-2.501 2.5v.417"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 15.006,
    height: 15.006,
    x: 2.497,
    y: 2.497,
    rx: 3
  }))));
};
export default SvgWallet;